module.exports = __webpack_public_path__ + "static/media/trophy.12674a86.svg";